import React from "react";
import "./MakeMoneyOnlineToday.css";

const MakeMoneyOnlineToday = () => {
  return (
    <div className="makeMoneyOnlineToday-parent-div">
      <div className="makeMOneyOnlineToday-first-text-div">
        <div className="job_preparation_div">
          {/* <h1 className="makeMOneyOnlineToday-heading">Step 4</h1> */}
          <p className="Job_Preparation">Job Preparation Guideline</p>
          <p className="makeMOneyOnlineToday-p">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Est
            repellat nostrum quisquam cum delectus similique. Nulla, veniam. Qui
            quisquam quia maiores impedit quis, cum repudiandae illum
            praesentium maxime! In, laborum.
          </p>
        </div>
        <button className="step_four_buy_now_btn">Buy Now</button>
      </div>
    </div>
  );
};

export default MakeMoneyOnlineToday;
